<template>
  <v-row dense no-gutters>
    <v-col cols="12">
      <tbl-project-route :project="project" />
    </v-col>
  </v-row>
</template>

<script>
import { UI_SET_ACTIONS } from '@/store/actions/ui'

export default {
  name: 'projectRouteCard',
  components: {
    TblProjectRoute: () => import(/* webpackChunkName: "project" */ '@/components/modules/projects/ui/tblProjectRoute.vue')
  },
  props: {
    project: {
      type: Object,
      default: function () {
        return {}
      }
    },
    activeTab: {
      type: String,
      default: null
    }
  },
  data () {
    return {
    }
  },
  watch: {
    activeTab (val) {
      this.setActions()
    }
  },
  methods: {
    setActions () {
      this.$store.dispatch(UI_SET_ACTIONS, {
        actionType: 'Маршрут',
        actions: []
      })
    }
  },
  mounted () {
    this.setActions()
  }
}
</script>
